export const managePrimaryOrderColumnsMetaData = (showSiteId: boolean) => {


  return {

    columns: [
      {
        headerName: "Order No. & date",
        headerParts: { top: "Order No.", bottom: "& date" },
        mappedValue: "orderNumber,creationTime",
        width: 190,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Distributor Name & Code",
        headerParts: { top: "Distributor Name ", bottom: "& Code" },
  
        mappedValue: "outletName, outletCode",
        width: 200,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },

      ...(showSiteId
        ? [
            {
              headerName: "Site",
              mappedValue: "siteId",
              width: 100,
              headerAlign: "left",
              align: "left",
              truncateText: true,
            },
          ]
        : []),
     
    { headerName: "Quantity", mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", width: 120, headerAlign: "left", align: "left", 
      type: "viewprimaryorderconfigs", },
      {
        headerName: "Amount",
        mappedValue: "netAmount",
        width: 120,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Order Source",
        headerParts: { top: "Order", bottom: "source" },
        mappedValue: "source",
        width: 120,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Status",
        mappedValue: "status",
        width: 150,
        headerAlign: "left",
        align: "left",
      },
    ],
    Actions: ["view", "download"],
  }
}


export const managePrimaryOrderColumnsMetaDataV2 = (showSiteId: boolean) => {

  return {

    columns: [
      {
        headerName: "Order No. & date",
        headerParts: { top: "Order No.", bottom: "& Date" },
        mappedValue: "orderNumber,creationTime",
        width: 190,
        headerAlign: "left",
        align: "left",
        truncateText: true,
        sortKey: "creationTime",
        sortType: "date"
      },
      {
        headerName: "Distributor Name & Code",
        headerParts: { top: "Distributor Name ", bottom: "& Code" },
  
        mappedValue: "outletName, outletCode",
        width: 170,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },

      ...(showSiteId
        ? [
            {
              headerName: "Site",
              mappedValue: "siteId",
              width: 100,
              headerAlign: "left",
              align: "left",
              truncateText: true,
            },
          ]
        : []),
     
    { headerName: "Quantity", 
      headerParts: { top: "Ordered ", bottom: "Quantity" },
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", 
      width: 120, 
      headerAlign: "left", 
      align: "left", 
      type: "viewprimaryorderconfigs",
      sortKey: "normalizedQuantity",
      sortType: "number"
    },
    { headerName: "TotalQuantity", 
      headerParts: { top: "Total ", bottom: "Qty" },
      mappedValue: "totalConvertedCases", 
      width: 100, 
      headerAlign: "center", 
      align: "center", 
    },
      {
        headerName: "Amount",
        mappedValue: "netAmount",
        width: 120,
        headerAlign: "left",
        align: "left",

        sortKey: "netAmount",
        sortType: "number"
      },
      {
        headerName: "Order Source",
        headerParts: { top: "Order", bottom: "source" },
        mappedValue: "source",
        width: 120,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Status",
        mappedValue: "status",
        width: 150,
        headerAlign: "left",
        align: "left",
      },
    ],
    Actions: ["view", "download"],
  }
}